/* Tuki Rubbelfeld — Gamification im Klaviyo-Popup (Formular TVDHZF, EN/FR-Popups).

   Das Script kennt DREI Marker. Welcher im DOM steht, entscheidet das
   Formular bzw. die Klaviyo-Variante; das Formular bleibt komplett nativ.

     #tk-rubbel-on     DE-Popup (heute live). Canvas ueber dem nativen
                       Coupon-Block (.klaviyo-coupon) auf dem Success-Step.
                       Freigerubbelt wird der CODE.

     #tk-rubbel-intl   EN- und FR-Popup (neu 05.10.2026). Gleiche Mechanik wie
                       #tk-rubbel-on. Eigener Marker, damit aeltere Fassungen
                       dieses Scripts ihn ignorieren: dort bleibt der Code
                       einfach offen sichtbar, statt mit deutschem Hinweistext
                       zugedeckt zu werden.

     #tk-rubbel-wert   Arm C. Canvas ueber einer Wert-Kachel auf SCHRITT 1,
                       ueber der Alters-Frage. Freigerubbelt wird nur der WERT
                       ("30.- Rabatt"), nicht der Code.

   Sprache: der Hinweistext auf dem Canvas richtet sich nach <html lang>,
   das Shopify aus request.locale setzt (de / en / fr). Unbekannt -> Deutsch.

   Enthaelt ein Formular keinen der Marker, passiert gar nichts.

   ZWEI LEHREN AUS DEM LIVE-TEST VOM 14.09., beide hier eingebaut:
   (1) Nichts aus fremdem CSS beziehen. Geometrie UND Typografie setzt das
       Script selbst inline. Frueher kam die Geometrie aus Klaviyos Custom
       CSS — lud das nicht, klappte das Canvas auf volle Attributgroesse auf
       und sprengte das Layout.
   (2) Nichts in fremdes Layout einfuegen. Klaviyos Coupon sitzt in einer
       flex-nowrap-Zeile; ein zusaetzlicher Hinweis-Absatz wurde dort zum
       zweiten Zeilenelement und hat den Coupon zusammengedrueckt. Der
       Hinweistext steht deshalb auf dem Canvas selbst.

   Sicherheitsprinzip: der echte Inhalt steht im DOM, das Canvas wird nur
   DARUEBER gelegt. Laeuft dieses Script nicht, ist der Inhalt einfach
   sichtbar. Zusaetzlich deckt ein Timer nach 20 s automatisch auf. */
(function () {
  'use strict';

  var COVER = '#8F5652';
  var AUTO_REVEAL_MS = 20000;
  var FONT = "Rubik, Arial, Helvetica, sans-serif";

  var LANG = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();

  // Hinweistexte auf dem Canvas, je Marker und Sprache: [Titel, Unterzeile].
  var TEXTS = {
    code: {
      de: ['Freirubbeln', 'ZUM AUFDECKEN DARÜBERFAHREN'],
      en: ['Scratch to reveal', 'SWIPE OVER IT TO UNCOVER'],
      fr: ['Grattez ici', 'PASSEZ DESSUS POUR DÉCOUVRIR']
    },
    wert: {
      de: ['Rubbel deinen Rabatt frei', 'MIT DEM FINGER DARÜBERFAHREN'],
      en: ['Scratch off your discount', 'SWIPE OVER IT WITH YOUR FINGER'],
      fr: ['Grattez votre réduction', 'PASSEZ VOTRE DOIGT DESSUS']
    }
  };
  function text(key, i) {
    var t = TEXTS[key];
    return (t[LANG] || t.de)[i];
  }

  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  /* Die Wert-Kachel auf Schritt 1 kommt als reines Markup aus dem
     Custom-HTML-Block (der Klaviyo-Sanitizer erlaubt dort weder style-
     Attribute noch <canvas>, aber id-Attribute ueberleben). Ihr Aussehen
     setzt deshalb das Script — an Klaviyos Coupon-Block angelehnt.
     Faellt das Script aus, steht der Wert als schlichter Text da. */
  function styleWertKachel(el) {
    var s = el.style;
    s.boxSizing = 'border-box';
    s.display = 'flex';
    s.flexDirection = 'column';
    s.alignItems = 'flex-start';
    s.justifyContent = 'center';
    s.margin = '0';
    s.padding = '16px 22px';
    s.minHeight = '104px';
    s.border = '1px solid #767676';
    s.background = '#FFFFFF';

    var betrag = document.getElementById('tk-rubbel-wert-betrag');
    if (betrag) {
      betrag.style.cssText = 'display:block;white-space:nowrap;font-family:' + FONT + ';' +
        'font-weight:300;line-height:1.1;color:#8F5652;';
      // Der Betrag muss auf EINE Zeile, sonst wird die Kachel auf dem iPhone
      // doppelt so hoch (im Harness gemessen). Deshalb von 38px abwaerts
      // anpassen, bis es in die Kachel passt.
      // Laufweite bewusst knapp: der Wert steht gemischt gesetzt da
      // ("30.- Rabatt"), nicht in Versalien wie der Coupon-Code. Weite
      // Sperrung zerreisst Mixed Case.
      var platz = el.clientWidth - 44;                 // 22px Innenabstand je Seite
      for (var px = 38; px >= 24; px -= 2) {
        betrag.style.fontSize = px + 'px';
        betrag.style.letterSpacing = Math.max(1, Math.round(px / 24)) + 'px';
        if (!platz || betrag.scrollWidth <= platz) break;
      }
    }
    var zusatz = document.getElementById('tk-rubbel-wert-zusatz');
    if (zusatz) {
      zusatz.style.cssText = 'display:block;font-family:' + FONT + ';font-size:12px;' +
        'font-weight:300;letter-spacing:.4px;line-height:1.7;color:#767676;margin-top:6px;';
    }
  }

  function findCoupon() {
    // Der native Coupon-Block, damit alle Popups exakt dieselbe Code-Mechanik
    // haben (Klick zum Kopieren). '.klaviyo-coupon' ist die echte, stabile
    // Klasse — die Nachbarklassen sind gehashte Buildnamen, darauf nie hashen.
    return document.querySelector('.klaviyo-coupon') || document.getElementById('tk-rubbel');
  }

  var TARGETS = [
    { marker: 'tk-rubbel-on',   find: findCoupon, prep: null, texts: 'code' },
    { marker: 'tk-rubbel-intl', find: findCoupon, prep: null, texts: 'code' },
    {
      marker: 'tk-rubbel-wert',
      find: function () { return document.getElementById('tk-rubbel-wert'); },
      prep: styleWertKachel,
      texts: 'wert'
    }
  ];

  function build(wrap, cfg) {
    if (wrap.getAttribute('data-tk-rubbel') === 'on') return;
    wrap.setAttribute('data-tk-rubbel', 'on');

    // Erst das Aussehen, dann messen — sonst stimmt die Canvas-Groesse nicht.
    if (cfg.prep) { try { cfg.prep(wrap); } catch (e) {} }

    // Wer Animationen reduziert haben will, bekommt den Inhalt direkt.
    if (reducedMotion()) return;

    var cv = document.createElement('canvas');
    if (!cv.getContext) return;                       // kein Canvas -> Inhalt bleibt sichtbar
    var ctx = cv.getContext('2d');
    if (!ctx) return;
    cv.id = 'tk-rubbel-cv';
    cv.setAttribute('aria-hidden', 'true');

    if (window.getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }
    wrap.style.overflow = 'hidden';
    wrap.style.webkitUserSelect = 'none';
    wrap.style.userSelect = 'none';

    cv.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;' +
                       'display:block;touch-action:none;cursor:grab;z-index:2;' +
                       'transition:opacity .45s ease;';

    var dpr = window.devicePixelRatio || 1;
    var done = false, drawing = false, last = null, w = 0, h = 0;
    var title = text(cfg.texts, 0), sub = text(cfg.texts, 1);

    function paint() {
      var r = wrap.getBoundingClientRect();
      w = r.width; h = r.height;
      if (!w || !h) return false;
      cv.width = Math.round(w * dpr);
      cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = COVER;
      ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = '#FFFFFF';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '400 17px ' + FONT;
      ctx.fillText(title, w / 2, h / 2 - 11);
      ctx.font = '300 11px ' + FONT;
      ctx.letterSpacing = '2px';
      ctx.fillText(sub, w / 2, h / 2 + 14);
      ctx.letterSpacing = '0px';
      ctx.globalCompositeOperation = 'destination-out';
      return true;
    }

    wrap.appendChild(cv);
    if (!paint()) { cv.parentNode.removeChild(cv); return; }   // keine Groesse -> Inhalt sichtbar

    function pos(e) {
      var r = cv.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function erase(p) {
      ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 34;
      if (last) { ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
      ctx.beginPath(); ctx.arc(p.x, p.y, 17, 0, Math.PI * 2); ctx.fill();
      last = p;
    }
    function cleared() {
      try {
        var d = ctx.getImageData(0, 0, cv.width, cv.height).data, n = 0, t = 0;
        for (var i = 3; i < d.length; i += 4 * 24) { t++; if (d[i] < 40) n++; }
        return t ? n / t : 0;
      } catch (err) { return 0; }
    }
    function finish() {
      if (done) return;
      done = true;
      cv.style.opacity = '0';
      setTimeout(function () {
        if (cv.parentNode) cv.parentNode.removeChild(cv);
      }, 500);
    }
    function down(e) {
      if (done) return;
      drawing = true; last = null; erase(pos(e));
      if (cv.setPointerCapture && e.pointerId != null) {
        try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      }
      if (e.preventDefault) e.preventDefault();
    }
    function move(e) {
      if (!drawing || done) return;
      erase(pos(e));
      if (cleared() > 0.45) finish();
      if (e.preventDefault) e.preventDefault();
    }
    function up() {
      if (done) return;
      drawing = false; last = null;
      if (cleared() > 0.28) finish();
    }

    if (window.PointerEvent) {
      cv.addEventListener('pointerdown', down);
      cv.addEventListener('pointermove', move);
      cv.addEventListener('pointerup', up);
      cv.addEventListener('pointercancel', up);
      cv.addEventListener('pointerleave', function () { drawing = false; last = null; });
    } else {
      cv.addEventListener('mousedown', down);
      cv.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
      cv.addEventListener('touchstart', function (e) { down(e.touches[0]); }, { passive: false });
      cv.addEventListener('touchmove', function (e) { move(e.touches[0]); }, { passive: false });
      cv.addEventListener('touchend', up);
    }

    window.addEventListener('resize', function () { if (!done) { last = null; paint(); } });
    setTimeout(function () { if (!done) finish(); }, AUTO_REVEAL_MS);  // Inhalt nie einsperren
  }

  function scan() {
    for (var i = 0; i < TARGETS.length; i++) {
      var cfg = TARGETS[i];
      if (!document.getElementById(cfg.marker)) continue;
      var el = cfg.find();
      if (el) build(el, cfg);
    }
  }

  function start() {
    scan();
    try {
      new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    // Klaviyo-eigene Events als zusaetzlicher Ausloeser, falls der Observer
    // einmal nicht greift. Bei Arm C ist das der Schrittwechsel.
    window.addEventListener('klaviyoForms', function (e) {
      if (e && e.detail && (e.detail.type === 'submit' || e.detail.type === 'stepSubmit' ||
                            e.detail.type === 'open' || e.detail.type === 'embedOpen')) {
        setTimeout(scan, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
